import { formatValue } from 'react-currency-input-field';
import { ThumbnailPhotoCard } from '@peacecover/component';
import { intlConfig } from '@pocapan/shared/utils/CurrencyUtil';
import HorizontalScroll from '../../my-page/components/HorizontalScroll';
import type { UserDataType } from '../../types/UserType';
import { useSelectedTradingCardsStore } from '../store/useSelectedTradingCardsStore';
import { t } from 'i18next';

interface SelectedPhotoCardsListProps {
  user: UserDataType;
}

const SelectedPhotoCardsList = ({ user }: SelectedPhotoCardsListProps) => {
  const selectedPhotoCards = useSelectedTradingCardsStore((state) => state.selectedPhotoCards);
  return (
    <HorizontalScroll>
      <div className="px-[24px] flex flex-row gap-[7px]">
        {selectedPhotoCards.map((card) => (
          <div key={card.tradingPhotoCardId} className="flex flex-col">
            <div className="flex items-center justify-center w-[99px] py-[12px] bg-separator1 rounded-[20px]">
              <ThumbnailPhotoCard
                imageUrl={card.photoCard.pictureUrl}
                className="w-[48px] h-[75px]"
              />
            </div>
            <p className="h-[18px] mt-[6px] mb-[12px] text-[15px] font-semibold text-text-primary truncate max-w-[99px]">
              {card.price
                ? formatValue({
                    value: card.price,
                    intlConfig: intlConfig(user) || { locale: 'ko-KR', currency: 'KRW' }
                  })
                : t('NewTradingPhotoCards.pricePlaceholder')}
            </p>
          </div>
        ))}
      </div>
    </HorizontalScroll>
  );
};

export default SelectedPhotoCardsList;
